import { CircularProgress } from '../CircularProgress';

import { StyledButton } from './Button.styles';
import { ButtonClasses, ButtonProps } from './types';

/**
 * Button component.
 */
export const Button = ({
  label,
  mode = 'standard',
  disabled,
  loading,
  startIcon,
  className,
  fullWidth,
  colorVariant = 'primary',
  datax,
  href,
  onClick,
}: ButtonProps) => (
  <StyledButton
    disableRipple
    classes={{ icon: 'button-icon' }}
    className={className}
    colorVariant={colorVariant}
    datax={datax}
    disabled={disabled || loading}
    fullWidth={fullWidth}
    href={href}
    loading={loading}
    mode={mode}
    startIcon={startIcon}
    onClick={onClick}
  >
    <span className="button-label">{label}</span>
    {loading && (
      <span className="button-loading">
        <CircularProgress />
      </span>
    )}
  </StyledButton>
);

Button.classes = ButtonClasses;
